import api from "./Api";

class PedidoSubItemService {
  GetPedidoSubItem(payload) {
    return api.get("/v1/pedidoSubItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoSubItem(payload) {
    return api.post("/v1/pedidoSubItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoSubItem(payload) {
    return api.put("/v1/pedidoSubItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoSubItem(payload) {
    return api.delete("/v1/pedidoSubItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoSubItemOData(payload) {
    return api.get("/OData/PedidoSubItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoSubItemService();
